export default __webpack_public_path__ + "static/media/img_layout_bonito_logo.d4f74199.jpg";